// import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// import { AppModule } from './app/app.module';
import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { AppComponent } from './app/app.component';

import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { appConfig } from './app/app.config';

Sentry.init({
  dsn: 'https://fc0a0b09e0e386d8a612d27f8406dce1@o4510041001885701.ingest.us.sentry.io/4510045311729665',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

registerLocaleData(en);

bootstrapApplication(AppComponent, appConfig);
